import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowRight } from "lucide-react";

// Map of every section for this role, with a one-line description and a direct link.
export default function FeaturesDialog({ open, onOpenChange, groups = [], onSelect }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto z-[70]" data-testid="features-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Everything you can do here</DialogTitle>
          <DialogDescription>Pick any feature to jump straight to it.</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-x-8 gap-y-6 mt-2">
          {groups.map((g) => (
            <section key={g.key} data-testid={`features-group-${g.key}`}>
              <h3 className="text-[11px] uppercase tracking-widest font-semibold text-[#8FA89B] mb-2">{g.label}</h3>
              <ul className="space-y-1">
                {g.items.map((it) => (
                  <li key={it.key}>
                    <button onClick={() => onSelect(it.key)} data-testid={`features-link-${it.key}`}
                      className="group w-full text-left rounded-xl px-3 py-2 hover:bg-[#144F75]/[0.06] transition-colors">
                      <span className="flex items-center gap-1.5 text-sm font-medium text-[#1A242B]">
                        {it.label} <ArrowRight size={13} className="opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity text-[#144F75]" />
                      </span>
                      {it.desc && <span className="block text-xs text-[#4A5D6B] mt-0.5">{it.desc}</span>}
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
